<template>
    <b-container>
        <b-row>
            <b-col md="12">
                <h1>Notifications</h1>

                <b-form inline style="align-items: flex-end;" @submit.prevent="saveNotification">
                    <b-form-group label="Days before expiration">
                        <b-input v-model="notification"></b-input>
                    </b-form-group>
                    
                    <b-btn type="submit" variant="primary" class="ml-2">Save</b-btn>
                </b-form>

                <p class="mt-4"><b>The following users receive notifications</b></p>
                <b-table class="mt-2" :fields="fields" :items="notifyUsers">
                    <template v-slot:cell(idNo)="data">
                        {{ data.value || '' }}
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            notification: 0,
            notifyUsers: [],
            fields: ['idNo', 'firstName', 'lastName', 'department', 'company']
        }
    },
    methods: {
        saveNotification() {
            axios.put('/api/settings/notification', { name: 'days', value: this.notification });
        }
    },
    created() {
        const notificationQuery = axios.get('/api/settings/notification');
        const notifyUsersQuery = axios.get('/api/persons', { params: { notify: true } });

        Promise.all([notificationQuery, notifyUsersQuery])
        .then(res => {
            this.notification = res[0].data;
            this.notifyUsers = res[1].data.result;
        })
    }
}
</script>